module.exports = ".menu-link {\n  color: gray;\n  /*color: red;*/\n}\n\n"